import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=352d3bff&scoped=true"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"
import style0 from "./profile.vue?vue&type=style&index=0&id=352d3bff&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352d3bff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-kr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('352d3bff')) {
      api.createRecord('352d3bff', component.options)
    } else {
      api.reload('352d3bff', component.options)
    }
    module.hot.accept("./profile.vue?vue&type=template&id=352d3bff&scoped=true", function () {
      api.rerender('352d3bff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile.vue"
export default component.exports